import { HttpErrorResponse, HttpInterceptorFn } from "@angular/common/http";
import { inject } from "@angular/core";
import { catchError, of, switchMap, take, throwError, timer } from "rxjs";
import { ApiStore } from "../+state/api";
import { FormErrorResponse } from "../+state/api/api-state.model";
import { Router } from "@angular/router";
import { AuthService } from "@auth0/auth0-angular";
import { AuthStore } from "../+state/auth";

export const httpErrorInterceptor: HttpInterceptorFn = (req, next) => {
  const apiStore = inject(ApiStore);
  const router = inject(Router);
  const authService = inject(AuthService);
  const authStore = inject(AuthStore);

  return next(req).pipe(
    catchError((response) => {
      if (response instanceof HttpErrorResponse) {
        if (response.status === 401) {
          return authService.getAccessTokenSilently().pipe(
            take(1),
            catchError(() => of(null)),
            switchMap((token: string | null) => {
              if (token) {
                authStore.setToken(token);
                const newReq = req.clone({
                  setHeaders: {
                    Authorization: `Bearer ${token}`,
                  },
                });
                return next(newReq);
              } else {
                if (response.error.errors) {
                  const errors = (response.error as FormErrorResponse).errors.map((err, index) => {
                    if (index === 0) {
                      err.detail = "You are not authorized to access this resource.";
                    }
                    return err;
                  });
                  response.error.errors = errors;
                }

                timer(1500)
                  .pipe(take(1))
                  .subscribe(() => router.navigate(["logout"]));

                apiStore.setApiError(response.error as FormErrorResponse, () => {
                  router.navigate(["logout"]);
                  apiStore.clearError();
                });
                return throwError(() => response);
              }
            }),
          );
        } else {
          apiStore.setApiError(response.error as FormErrorResponse);
        }
      }
      return throwError(() => response);
    }),
  );
};
